import { getAuth } from 'firebase/auth';
import { addDoc, collection, doc, getDocs, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/InventoryAddItems.css';
import { db } from "../firebase-config";

const InventoryAddItems = () => {
  const [date, setDate] = useState('');
  const [items, setItems] = useState([{ item: '', quantity: '' }]);
  const [options, setOptions] = useState([]);
  const [currentUserEmail, setCurrentUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const currentDate = new Date().toISOString().split('T')[0]; // Format date as YYYY-MM-DD
    setDate(currentDate);
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsRef = collection(db, 'products');
        const querySnapshot = await getDocs(productsRef);
        const products = querySnapshot.docs.map(doc => ({
          value: doc.id,
          label: doc.data().name
        }));
        setOptions(products.sort((a, b) => a.label.localeCompare(b.label)));
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchCurrentUserEmail = async () => {
      try {
        const user = await getAuth().currentUser;
        if (user && user.email) {
          setCurrentUserEmail(user.email);
        } else {
          console.log('No email found for current user');
        }
      } catch (error) {
        console.error('Error fetching current user email:', error);
      }
    };
  
    fetchCurrentUserEmail();
  }, []);

  const addItemLog = async (itemData) => {
    try {
      const currentDate = new Date();

      const formattedDate = [
        currentDate.getMonth() + 1,
        currentDate.getDate(),
        currentDate.getFullYear()
      ].join('/') + ' ' +
      [currentDate.getHours(), currentDate.getMinutes()].join(':');

      await addDoc(collection(db, 'item_logs'), {
        itemName: itemData.name,
        typeOfChange: 'Add Item',
        lastUpdatedBy: currentUserEmail,
        date: formattedDate,
        descriptionOfChange: 'Added',
        quantity: parseFloat(itemData.quantity),
        editChangeLog: '-',
      });
    } catch (error) {
      console.error('Error adding log:', error);
    }
  };

  // Handle change in the fields
  const handleInputChange = (index, e) => {
    const values = [...items];
    values[index][e.target.name] = e.target.value;
    setItems(values);
  };

  // Add a new item row
  const addItemRow = () => {
    setItems([...items, { item: '', quantity: '' }]);
  };

  // Remove an item row
  const removeItemRow = (index) => {
    const values = [...items];
    values.splice(index, 1);
    setItems(values);
  };

  // Calculate total quantity (or any other logic you may want)
  const totalQuantity = items.reduce((total, item) => total + (parseFloat(item.quantity) || 0), 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = { date, items, userEmail: currentUserEmail };

    try {
      setIsLoading(true); // Set loading state to true

      const productsCollectionRef = collection(db, 'products');
      
      for (const item of formData.items) {
        if (item.item) {
          const productDocRef = doc(productsCollectionRef, item.item);
          
            // Read the current quantity
          const snapshot = await getDocs(collection(db, 'products'));
          let productData;
          snapshot.forEach(doc => {
            if (doc.id === item.item) {
              productData = doc.data();
            }
          });

            // Update the quantity
          const newQuantity = parseFloat(productData.quantity) + parseFloat(item.quantity);
          
          // Write the updated quantity back to Firestore
          await updateDoc(productDocRef, {
            quantity: newQuantity,
            lastUpdatedBy: currentUserEmail,
          });

          // Get the full product details for logging
          const productDetails = options.find(opt => opt.value === item.item);
          const logItem = {
            name: productDetails ? productDetails.label : '',
            quantity: item.quantity,
            lastUpdatedBy: currentUserEmail,
          };

          // Add log to inventory_logs collection
          await addItemLog(logItem);
          console.log('Product/s successfully updated');
        }
      }
      
      toast.success("Product/s successfully added", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      
      // Reset the form
      setItems([{ item: '', quantity: '' }]);
    } catch (error) {
      console.error('Error updating products:', error);
      toast.error(`Failed to update product: ${error.message}`);
    } finally {
      setIsLoading(false); // Reset loading state
    }
    
    console.log('Form Submitted:', formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1>Add Product Quantity</h1><br /><br />

      {/* Date field */}
      <div className="form-row">
        <div className="form-field">
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>

      {/* Loop over the items array to generate item rows dynamically */}
      {items.map((item, index) => (
        <div key={index} className="form-row">
          <div className="form-field">
            <label>Item:</label>
            <select
              name="item"
              value={item.item}
              onChange={(e) => handleInputChange(index, e)}
              required
            >
              <option value="">Select Item</option>
              {options.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div className="form-field">
            <label>Quantity:</label>
            <input
              type="number"
              name="quantity"
              value={item.quantity}
              onChange={(e) => handleInputChange(index, e)}
              required
            />
          </div>

          {/* Remove Button */}
          <div className="remove-item">
            <button
              type="button"
              onClick={() => removeItemRow(index)}
              className="remove-button"
              disabled={items.length === 1} // Disable remove button if only one item
            >
              Remove Item
            </button>
          </div>
        </div>
      ))}

      {/* Button to add another item row */}
      <button type="button" className='add-another-item-additems' onClick={addItemRow}>Add Another Item</button>


          <button type="submit" className="save-entries-btn" disabled={isLoading}>
          {isLoading ? 'Submitting...' : 'Submit'}
          </button>

      {/* Total Quantity */}
      <div className="total-container">
        <span className="total-label">Total Quantity:</span>
        <span className="total-value">{totalQuantity}</span>
      </div>

      <div className="user-email">
        <span>Email: {currentUserEmail}</span>
      </div>
    </form>
  );
};

export default InventoryAddItems;